/**
 * @module web/store
 * @private
 */

import { cache } from "../persistence/cache";
import { getCookieByName } from "../../utils/cookiesUtils";

/**
 * Update the session token with the given newToken. This token will be saved in memory and also in a local cache for a
 * period of 4 hours.
 * @param {String} newToken A JWT obtained from a backend call
 */
const updateToken = function(token) {
  setJWTTokenInLocalStorage(token);
  if (this.localCache && this.localCache.auth) {
    cache.set(
      "token",
      { token },
      {
        database: "auth",
        expiresIn: this.tokenExpirationTime
      }
    );
  }
};

/**
 * Returns the current session token, if any. The token will be searched in memory first and local cache as second
 * option.
 * @returns {string} A found JWT or null if none memory nor cache have a valid token.
 */
const getToken = async function() {
  let token = null;
  if (this.localCache && this.localCache.auth) {
    const cachedToken = await cache.get("token", { database: "auth" });
    token = cachedToken && cachedToken.token;
    setJWTTokenInLocalStorage(token);
  }
  if (!token && this.jwtCookie) {
    token = getCookieByName(this.jwtCookie.name);
    setJWTTokenInLocalStorage(token);
  }

  if (!token && localStorage.getItem("token")) {
    token = localStorage.getItem("token");
  }

  return token;
};

const updateSPXToken = function(spxToken) {
  setSPXTokenInLocalStorage(spxToken);
  if (this.localCache && this.localCache.auth) {
    cache.set(
      "spxToken",
      { spxToken },
      {
        database: "auth",
        expiresIn: this.tokenExpirationTime
      }
    );
  }
};

const getSPXToken = async function() {
  let spxToken = null;
  if (this.localCache && this.localCache.auth) {
    spxToken = await cache.get("spxToken", { database: "auth" });
    if (spxToken && spxToken.spxToken) {
      spxToken = spxToken.spxToken;
      setSPXTokenInLocalStorage(spxToken);
    } else if (!spxToken) {
      spxToken = localStorage.getItem("spxToken");
    }
  }

  return spxToken;
};

const setJWTTokenInLocalStorage = function(newJWTToken) {
  if (!newJWTToken) return;

  localStorage.setItem("token", newJWTToken);
  return;
};

const setSPXTokenInLocalStorage = function(newSPXToken) {
  if (!newSPXToken) return;

  localStorage.setItem("spxToken", newSPXToken);
  return;
};

export default { updateToken, getToken, updateSPXToken, getSPXToken };
